<template>
  <div class="image-viewer-wrapper">
    <a-button @click="$emit('close')" class="mb-3">← Späť na dokumenty</a-button>

    <div class="image-container" ref="imageContainer">
      <img :src="src" ref="imgRef" @load="onImageLoad" @click="handleImageClick" />

      <div v-for="comment in comments" :key="comment.id">
        <a-tooltip :title="comment.text || 'Nový komentár'" placement="top">
          <div
            class="comment-marker"
            :style="getMarkerStyle(comment)"
            @click.stop="selectComment(comment)"
          >
            💬
          </div>
        </a-tooltip>
      </div>
    </div>

    <a-modal
      v-model="commentModalVisible"
      title="Komentár"
      :closable="true"
      :maskClosable="false"
      :footer="null"
      @open="focusCommentInput"
    >
      <div v-if="selectedComment">
        <a-textarea
          ref="commentInput"
          v-model="selectedComment.text"
          rows="4"
        />
        <div class="modal-footer">
          <a-button type="danger" @click="deleteComment">Zmazať</a-button>
          <a-button type="primary" @click="closeCommentModal">Uložiť</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    value: Array, // v-model na komentáre
  },
  data() {
    return {
      imageWidth: 1,
      imageHeight: 1,
      commentModalVisible: false,
      selectedComment: null,
      localComments: [],
    };
  },
  computed: {
    comments() {
      return this.localComments;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.localComments = [...newVal];
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {

    onImageLoad() {
      const img = this.$refs.imgRef;
      this.imageWidth = img.offsetWidth;
      this.imageHeight = img.offsetHeight;
    },
    handleImageClick(e) {
      const rect = this.$refs.imgRef.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;

      const newComment = {
        id: Date.now() + Math.random(),
        x,
        y,
        text: '',
      };

      this.localComments.push(newComment);
       this.$emit('update:comments', this.localComments)
      this.$emit('input', this.localComments);
      this.selectedComment = newComment;
      this.commentModalVisible = true;

      this.$nextTick(() => this.focusCommentInput());
    },
    selectComment(comment) {
      this.selectedComment = comment;
      this.commentModalVisible = true;
      this.$nextTick(() => this.focusCommentInput());
    },
    deleteComment() {
      this.localComments = this.localComments.filter(c => c.id !== this.selectedComment.id);
      this.$emit('input', this.localComments);
        this.$emit('update:comments', this.localComments)
      this.selectedComment = null;
      this.commentModalVisible = false;
    },
    closeCommentModal() {
      this.$emit('input', this.localComments);
       this.$emit('update:comments', this.localComments)
      this.commentModalVisible = false;
    },
    focusCommentInput() {
      this.$refs.commentInput?.focus?.();
    },
    getMarkerStyle(comment) {
      return {
        top: comment.y * this.imageHeight + 'px',
        left: comment.x * this.imageWidth + 'px',
        position: 'absolute',
      };
    }
  }
};
</script>

<style scoped>
.image-viewer-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.image-container {
  position: relative;
  display: inline-block;
}
img {
  max-width: 100%;
  border: 1px solid #ccc;
}
.comment-marker {
  position: absolute;
  font-size: 18px;
  cursor: pointer;
  z-index: 10;
  background: #ffc107;
  border-radius: 50%;
  padding: 2px 4px;
  line-height: 1;
}
.modal-footer {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
